<template>
  <div class="navigation-bar">
    <div class="nav-background">
      <div
        v-for="(item, index) in navItems"
        :key="item.path"
        :class="['nav-item', item.path === $route.path ? 'selected' : '']"
      >
        <router-link :to="item.path" class="nav-link">
          <component :is="item.icon"></component>
        </router-link>

        <!-- The Scoop is now part of each nav-item to track position perfectly -->
        <div class="nav-item-selected" v-if="item.path === $route.path">
          <div class="scoop-wrapper">
            <svg
              width="160"
              height="40"
              viewBox="0 0 160 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.5,0 C50,0 50,28 80,28 C110,28 110,0 127.5,0"
                stroke="var(--color-background)"
                stroke-width="0.5"
                fill="var(--color-background)"
              />
            </svg>
          </div>
          <div class="inner-circle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import {
  HomeOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  UserOutlined
} from '@ant-design/icons-vue'

const navItems = [
  {
    name: 'Home',
    icon: <HomeOutlined />,
    path: '/crew-connect/home'
  },
  {
    name: 'call-time',
    icon: <CalendarOutlined />,
    path: '/crew-connect/call-time'
  },
  {
    name: 'locations',
    icon: <EnvironmentOutlined />,
    path: '/crew-connect/locations'
  },
  {
    name: 'members',
    icon: <UserOutlined />,
    path: '/crew-connect/members'
  }
]
</script>

<style scoped lang="scss">
.navigation-bar {
  position: relative;
  width: 100%;
  padding: 0 12px;
  display: flex;
  justify-content: center;
}

.nav-background {
  display: flex;
  background-color: var(--color-nav-background);
  height: 64px;
  border-radius: 32px;
  width: 100%;
  max-width: 480px;
  justify-content: space-around;
  padding: 0;
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.08);
  position: relative;
  align-items: center;
}

.nav-item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
  position: relative;

  &.selected {
    z-index: 10;

    .nav-link {
      color: var(--color-nav-selected-text);
      transform: translateY(-42px);
    }
  }
}

.nav-link {
  color: var(--color-text);
  font-size: 24px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}

.nav-item-selected {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 64px;
  pointer-events: none;
  display: flex;
  justify-content: center;
}

.scoop-wrapper {
  position: absolute;
  top: -1px; // Ensure it overlaps the top edge perfectly
  width: 160px;
  height: 40px;
  z-index: 1;

  svg {
    width: 100%;
    height: 100%;
  }
}

.inner-circle {
  position: absolute;
  width: 56px;
  height: 56px;
  background-color: var(--color-nav-selected-background);
  border-radius: 50%;
  top: -38px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  box-shadow: 0 6px 12px rgba(115, 91, 242, 0.3);
}
</style>
